
import { IdleTimeOutComponent } from "./idletimeout.component";
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

@NgModule({
    imports: [      
        CommonModule
    ],
    declarations: [
        IdleTimeOutComponent
    ],
    exports: [
        IdleTimeOutComponent
    ]
})
export class IdleTimeOutModule {

}
